var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRhombusSplit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "background",
    d: "M17.4847 3.86974C18.6677 2.0497 21.3323 2.04969 22.5153 3.86974L31.9373 18.365C32.5835 19.3592 32.5835 20.6408 31.9373 21.635L22.5153 36.1303C21.3323 37.9503 18.6677 37.9503 17.4847 36.1303L8.06273 21.635C7.4165 20.6408 7.4165 19.3592 8.06273 18.365L17.4847 3.86974Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 38,
    height: 38
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10",
    d: "M17.4847 3.86974C18.6677 2.0497 21.3323 2.04969 22.5153 3.86974L31.9373 18.365C32.5835 19.3592 32.5835 20.6408 31.9373 21.635L22.5153 36.1303C21.3323 37.9503 18.6677 37.9503 17.4847 36.1303L8.06273 21.635C7.4165 20.6408 7.4165 19.3592 8.06273 18.365L17.4847 3.86974Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M33 20H7L10 18.5H30L33 20Z",
    fill: "black",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M20 3.5L30 18.5L33 20L20 0V3.5Z",
    fill: "black",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 8",
    d: "M20 3.5L10 18.5L7 20L20 0V3.5Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M33 20H7L10 21.5H30L33 20Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M20 36.5L30 21.5L33 20L20 40V36.5Z",
    fill: "black",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M20 36.5L10 21.5L7 20L20 40V36.5Z",
    fill: "white",
    fillOpacity: 0.4
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRhombusSplit);
export default __webpack_public_path__ + "static/media/rhombus-split.7d40643b71a373e859b091c91daf7339.svg";
export { ForwardRef as ReactComponent };